import React, { useContext, useEffect, useState } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import MainButton from "../../../../shared/components/MainButton";
import { Box, List, ListItem } from "@material-ui/core";
import IconTitle from "../../../../shared/components/IconTitle";
import { assetIds, ThemedAsset } from "nemuru-components";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import Text from "../../../../shared/components/Text";
import { useTheme } from "@material-ui/styles";
import { MainCircularProgress } from "../../../../shared/components/MainCircularProgress";
import Typography from "@material-ui/core/Typography";
import { constructProgressEvent } from "../../../../../utils/constructProgressEvent";
import { useEventDispatcher } from "../../../../../utils/hooks/useEventDispatcher";

const TIMEOUT_STEP_GET_SIGNATURE = 3000;
const TIMEOUT_END_GET_SIGNATURE = 30000;

const SignatureInfoText = () => {
  const { palette } = useTheme();
  return (
    <Box className="appear-anim">
      <Box display="inline-flex" justifyContent="center">
        <List>
          <ListItem style={{ alignItems: "start" }}>
            <i
              className="material-icons-outlined"
              style={{
                fontSize: 16,
                color: palette.text.secondary,
                verticalAlign: "text-top",
                paddingRight: 10,
              }}
            >
              draw
            </i>
            <Typography variant="caption">
              <Text tId="DIGITAL_SIGNATURE_INFO" />
            </Typography>
          </ListItem>
          <ListItem style={{ alignItems: "start" }}>
            <i
              className="material-icons-outlined"
              style={{
                fontSize: 16,
                color: palette.text.secondary,
                verticalAlign: "text-top",
                paddingRight: 10,
              }}
            >
              pageview
            </i>
            <Typography variant="caption">
              <Text tId="REVIEW_SIGNATURE_INFO" />
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default function SignatureEmbeddedSAML({ onSuccess }) {
  const {
    state: { loan, signatureChannel, lastRequest, currentModuleObject },
    dispatch,
  } = useContext(ProcessContext);

  const [showIframe, setShowIframe] = useState(false);
  const [signatureEnded, setSignatureEnded] = useState(false);
  const [pollingTimeState, setPollingTimeState] = useState(0);

  const { palette } = useTheme();

  const { dispatchEvent } = useEventDispatcher();
  useEffect(() => {
    const progressEvent = constructProgressEvent(
      currentModuleObject?.id,
      "SIGNATURE_EMBEDDED_SAML"
    );
    dispatchEvent(progressEvent);
  }, []);

  useEffect(() => {
    if (signatureEnded) {
      switch (lastRequest.type) {
        case "REQUEST_PATCH_UPDATE_SIGNATURE_STATUS_FOR_LOAN_LENDER_BORROWER_CONTRACT_FULFILLED":
          checkSignatureSuccess();
          break;
        case "REQUEST_GET_LOAN_FULFILLED":
          checkSignatureSuccess();
          break;
        default:
          break;
      }
    }
  }, [lastRequest]);

  const eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent";
  const eventer = window[eventMethod];
  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

  eventer(messageEvent, (e) => onCallBackEvent(e));

  const onCallBackEvent = (e) => {
    if (e.data.msg === "callback:end") {
      setShowIframe(false);
      setSignatureEnded(true);
      dispatch({
        type: "REQUEST_PATCH_UPDATE_SIGNATURE_STATUS_FOR_LOAN_LENDER_BORROWER_CONTRACT",
        payload: loan.loan_application_selected.id,
      });
    }
  };

  const isContractSigned =
    loan?.loan_application_selected?.loan_lender_borrower_contract?.is_signed;

  const checkSignatureSuccess = () => {
    if (!isContractSigned) {
      timeoutGetLoan(TIMEOUT_STEP_GET_SIGNATURE);
    } else {
      onSuccess();
    }
  };

  const timeoutGetLoan = (time) => {
    if (pollingTimeState < TIMEOUT_END_GET_SIGNATURE) {
      setTimeout(() => {
        dispatch({
          type: "REQUEST_GET_LOAN",
          payload: loan.id,
        });
      }, time);
      setPollingTimeState(pollingTimeState + time);
    }
  };

  function startIframe() {
    setShowIframe(true);
    document.getElementById("formSAML").action = signatureChannel?.url;
    document.getElementById("formSAML").submit();
  }

  const iframeStyle = {
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    border: 0,
    visibility: showIframe ? "visible" : "hidden",
  };

  const disabled = showIframe || signatureEnded;
  return (
    <>
      <Box className="appear-anim">
        <Box style={{ height: "5vh" }} />
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_DOC_SIGNATURE}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={"CONTRACT_SIGNATURE"} />}
          subtitle={<Text tId={"PROCEED_TO_DIGITAL_SIGNATURE"} />}
        />
        {disabled ? (
          <Typography variant="body2" align="center">
            <Text tId={signatureEnded ? "RETRIEVING_DATA" : "CONNECTING"} />
          </Typography>
        ) : (
          <>
            <Box style={{ height: "5vh" }} />
            <SignatureInfoText />
          </>
        )}

        <Box style={{ height: "5vh" }} />
        {disabled && (
          <MainCircularProgress
            color={palette.secondary.main}
            textId={"PLEASE_WAIT"}
          />
        )}
      </Box>
      <form
        name="formSAML"
        id="formSAML"
        target="iFrameLgt"
        method="post"
        action="https://www.logalty.es:443/lgt/lgtfrontend/login/samlLogin"
      >
        <textarea
          hidden={true}
          id="saml_assertion"
          name="saml_assertion"
          value={signatureChannel?.saml}
        />
        <iframe
          align="center"
          name="iFrameLgt"
          id="iFrameLgt"
          style={iframeStyle}
        />
      </form>
      {!disabled && (
        <MainButton onClick={startIframe}>
          <Text tId={"SIGN"} />
        </MainButton>
      )}
      {/*{!disabled && <MainButton onClick={() => onCallBackEvent({ data: { msg: "callback:end" } })} />}*/}
    </>
  );
}
